import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import {
  QrScanPage, DailyInspectionPageQr, PeriodicInspectionPageQr,
  DailyInspectionPage, PeriodicInspectionPage
} from './lazyRoutes'

/**
 * QR 스캔/점검 라우트
 * App.jsx에서 {qrRoutes}로 삽입
 */
export const qrRoutes = [
  <Route key="qr-scan" path="/qr/scan" element={<ProtectedRoute allowedRoles={['plant', 'maker']}><QrScanPage /></ProtectedRoute>} />,
  <Route key="qr-daily-old" path="/qr/daily-inspection/:sessionId" element={<ProtectedRoute allowedRoles={['plant']}><DailyInspectionPageQr /></ProtectedRoute>} />,
  <Route key="qr-periodic-old" path="/qr/periodic-inspection/:sessionId" element={<ProtectedRoute allowedRoles={['plant']}><PeriodicInspectionPageQr /></ProtectedRoute>} />,
  <Route key="qr-daily" path="/qr/daily-inspection/:sessionId/:moldId" element={<ProtectedRoute allowedRoles={['plant']}><DailyInspectionPage /></ProtectedRoute>} />,
  <Route key="qr-periodic" path="/qr/periodic-inspection/:sessionId/:moldId" element={<ProtectedRoute allowedRoles={['plant']}><PeriodicInspectionPage /></ProtectedRoute>} />,
]
